import { ExportTemplate, GlobalConfigVo, SysDictItem } from 'typings/openapi';
import { OptionType } from '../types';
import { PurchaseMode } from './data';

export interface Menu {
  /**
   * 图标
   */
  icon: string;
  /**
   * 选中图标
   */
  selectIcon: string;
  /**
   * id
   */
  id: number;
  /**
   * 菜单名称
   */
  name: string;
  /**
   * 父id
   */
  parentId: number;
  /**
   * 路径
   */
  path: string;
  /**
   * 排序
   */
  sort: number;
  /**
   * 层级
   */
  level: number;
  children?: Menu[];
}

export interface Option {
  label: string;
  value: string | number;
}

/**
 * 导出字段的类型
 */
export enum ExportFiledType {
  /** 商品 */
  PRODUCT = '1',
  /** 需方 */
  PURCHASE = '2',
  /** 供方 */
  SUPPLIER = '3',
  /** 质检报告 */
  QUALITY_INSPECTION_REPORT = '4',
  /** 采购单 */
  PURCHASE_ORDER = '5',
  /** 应收汇总 */
  RECEIVABLE_SUMMARY = '6',
  /** 应付汇总 */
  PAYABLE_SUMMARY = '7',
  /** 计划到货明细 */
  PLAN_DELIVERY_INFO = '8',
  /** 采购需求汇总 */
  PURCHASE_REQUIRE_SUMMARY = '9',
  /** 供方采购汇总商品 */
  SUPPLY_PROCUREMENT_SUMMARY = '10',
  /** 需方采购汇总商品 */
  PURCHASE_PROCUREMENT_SUMMARY = '11',
  /** 监管方采购汇商品 */
  MANAGE_PROCUREMENT_SUMMARY = '12',
  /** 供方采购汇总需方 */
  SUPPLY_PROCUREMENT_DEMAND_SUMMARY = '13',
  /** 监管方采购汇总需方 */
  PURCHASE_PROCUREMENT_DEMAND_SUMMARY = '14',
  /** 需方采购汇总供方 */
  SUPPLY_PROCUREMENT_SUPPLY_SUMMARY = '15',
  /** 监管方采购汇总供方 */
  PURCHASE_PROCUREMENT_SUPPLY_SUMMARY = '16',
  /** 需方申购商品明细 */
  PURCHASE_APPLY_GOODS_DETAIL = '17',
  /** 监管方申购需求汇总 --- 按商品 */
  MANAGE_APPLY_PURCHASE_SUMMARY = '18',
  /** 监管方导出申购单 */
  MANAGE_APPLY_PURCHASE = '19',
  /** 需方导出申购单 */
  PURCHASE_APPLY_PURCHASE = '20',
  /** 监管方/供方采购合同的批量导出 */
  MANAGE_SUPPLY_PURCHASE_CONTRACT = '21',
  /** 供方商品 */
  SupplyCommodity = '24',
  /** 组合商品 */
  ComposeProduct = '22',
  /** 需方菜谱管理 */
  PurchaserCookbook = '25',
  /** 监管方菜谱管理 */
  ManageCookbook = '26',
  COMPOSE_PRODUCT = '22',
  /** 菜谱汇总 */
  COOKBOOK_SUMMARY = '23',
  /** 账户管理 */
  ACCOUNT_MANAGE = '27',
  /** 账户流水管理 */
  ACCOUNT_TURNOVER = '30',
  /** 库存台账列表导出 */
  INVENTORY_STOCK = '31',
  /** 实时库存列表导出 */
  INVENTORY_REALTIME = '32',
  /** 价格监控 */
  MANAGE_PRICE_MONITOR = '33',
  /** 需方价格监控 */
  PURCHASE_PRICE_MONITOR = '40',
  /** 供方价格监控 */
  SUPPLY_PRICE_MONITOR = '39',
  /** 入库单 */
  INBOUND_ORDER = '28',
  /** 出库单 */
  OUTBOUND_ORDER = '29',
  /** 申领单 */
  REQUISITION_ORDER = '46',
  /** 供方｜监管方支付流水导出 */
  PAYMENT_STATEMENT = '34',
  /** 需方支付流水导出 */
  PURCHASE_PAYMENT_STATEMENT = '41',
  /** 监管方对账单导出 */
  MANAGE_STATEMENT = '35',
  /** 需方对账单导出 */
  PURCHASE_STATEMENT = '36',
  /** 供方对账单导出 */
  SUPPLY_STATEMENT = '37',
  /** 供方绩效导出 */
  SupplierPerformance = '38',
  /** 需方｜监管方调度库存导出 */
  DISPATCH_INVENTORY = '45',
  /** AIO 营养成分导出 */
  AIO_NUTRIENT = '42',
  /** 盘点导出 */
  INVEBTORY_SHEET = '43',
  /** 物料转换 */
  MATERIAL_CONVERSION = '44',
  /** 开票记录导出（监管方，供方） */
  MANAGE_SUPPLY_BILL_RECORD = '47',
  /** 开票记录导出（需方） */
  PURCHASE_BILL_RECORD = '48',
  /** 补货记录 */
  REPLENISH_RULES = '51',
  /** 收支记录导出 */
  INCOME_EXPENSE_RECORD = '49',
  /** 财务汇总表 */
  FINANCIAL_SUMMARY = '50',
  /** 效期预警 */
  VALIDITY_WARNING = '52',
  /** 库存预警 */
  INWENTORY_WARNING = '53',
  /** 周转筐统计 */
  TURN_OVER_BASKET_STATISTICS = '54',
  /** 限价管理 */
  LIMIT_TIME = '55',
  /** 报餐汇总 */
  MEAL_SUMMARY = '56',
  /** 套餐管理 */
  PACKAGE_MANAGE = '57',
  /** 报餐记录 */
  MEAL_RECORD = '58',
  /** 套餐需求汇总 */
  PACKAGE_DEMAND_SUMMARY = '59',
  /** 监管方财务汇总表-按日期 */
  MANAGE_FINANCIAL_SUMMARY = '60',
  /** 监管方财务汇总表-按月 */
  MANAGE_FINANCIAL_MONTH_SUMMARY = '61',
  /** 统一定价 */
  UNIFORM_PRICE = '62',
  /** 商品税率 */
  TAX_RATE = '63',
  /** 就餐 */
  DINE_PERSONNAL = '65',
  /** 滞销品 */
  DEAD_STOCK = '64',
  /** 缴费单 */
  PAYMENT_RECEIPT = '67',
  /** 缴费记录 */
  PAYMENT_RECORDS = '66',
  /** 就餐人员 */
  ACCOMPANY_SUMMARY = '68',
  /** 班级 */
  CLASS_SUMMARY = '69',
  /** 员工 */
  EMPLOYEE_EXPORT = '70',
  /** 监管方缴费记录 */
  MANAGE_PAYMENT_RECORDS = '71',
  /** 需方就餐日历 */
  PURCHASER_DINING_CALENDAR = '72',
  /** 监管方就餐日历 */
  MANAGE_DINING_CALENDAR = '73',
  /** 监管方采购需求汇总-按商品 */
  MANAGE_PURCHASE_SUMMARY_PRODUCT = '74',
  /** 监管方采购需求汇总-按需方 */
  MANAGE_PURCHASE_SUMMARY_DEMAND = '75',
  /** 监管方采购需求汇总-按供方 */
  MANAGE_PURCHASE_SUMMARY_SUPPLIER = '76',
  /** 售后 */
  AFTER_SAFES = '77',
  /** 监管方自用菜谱管理 */
  ManageSelfCookbook = '78',
  /** 供方采购需求汇总-按需方 */
  SUPPLY_PURCHASE_SUMMARY_DEMAND = '79',
  /** 供方采购需求汇总-按食堂 */
  SUPPLY_PURCHASE_SUMMARY_DINING = '80',
  /** 需方画像 */
  PURCHASER_PORTRAIT = '81',
  /** 监管方采购需求汇总-按食堂 */
  MANAGE_PURCHASE_SUMMARY_DINING = '82',
  /** 食安统计表 */
  FOOD_SAFETY_REPORT = '83',
  /** 采购商品备注 */
  PURCHASE_SKU_REMARK = '84',
  /** 需方采购明细表 */
  PURCHASE_DETAIL_REPORT = '85',
  /** 司机绩效 */
  DRIVER_PERFORMANCE = '86',
  /** 数据仓库监管方采购汇总按商品 */
  MANAGE_PROCUREMENT_SUMMARY_BI = '88',
  /** 数据仓库监管方采购汇总按需方 */
  MANAGE_PROCUREMENT_DEMAND_SUMMARY_BI = '89',
  /** 数据仓库监管方采购汇总按供方 */
  MANAGE_PROCUREMENT_SUPPLY_SUMMARY_BI = '90',
  /** 数据仓库监管方财务汇总按日 */
  MANAGE_FINANCIAL_DATE_SUMMARY_BI = '99',
  /** 数据仓库监管方财务汇总按月*/
  MANAGE_FINANCIAL_MONTH_SUMMARY_BI = '100',
  /** 数据仓库需方采购汇总按商品 */
  PURCHASE_PROCUREMENT_SUMMARY_BI = '93',
  /** 数据仓库需方采购汇总按供方 */
  PURCHASE_PROCUREMENT_SUPPLY_SUMMARY_BI = '94',
  /** 数据仓库供方采购汇总按商品 */
  SUPPLY_PROCUREMENT_SUMMARY_BI = '91',
  /** 数据仓库供方采购汇总按需方 */
  SUPPLY_PROCUREMENT_DEMAND_SUMMARY_BI = '92',
  /** 按天统计收支汇总（财务汇总报表）-导出实现  --- 需方 模板id 95 */
  PURCHASE_FINANCIAL_DATE_SUMMARY_BI = '95',
  /** 按月统计收支汇总（财务汇总报表）-导出实现  --- 需方 模板id 96 */
  PURCHASE_FINANCIAL_MONTH_SUMMARY_BI = '96',
  /** 按天统计收支汇总（财务汇总报表）-导出实现  --- 供方 模板id 97 */
  SUPPLY_FINANCIAL_DATE_SUMMARY_BI = '97',
  /** 按月统计收支汇总（财务汇总报表）-导出实现  --- 供方 模板id 98 */
  SUPPLY_FINANCIAL_MONTH_SUMMARY_BI = '98',
  /** 导出食安统计 --- 模板id  = 87 */
  MANAGE_SAFE_SUMMARY_BI = '87',
  /** 需方库存明细表 */
  PURCHASE_STOCK_DETAIL_REPORT = '101',
  /** 供方采购明细表 */
  SUPPLY_DETAIL_REPORT = '102',
  /** 需方组汇总表 */
  PURCHASE_GROUP_SUMMARY = '103',
  /** 需方每日价格 */
  PURCHASE_DAILY_PRICE = '104',
  /** 计划到货明细 --- 按食堂 */
  PLAN_DELIVERY_DETAIL_DINING = '106',
  /** 计划到货明细 --- 按供方 */
  PLAN_DELIVERY_DETAIL_SUPPLIER = '107',
  /** 需方采购汇总表 --- 按食堂 */
  PURCHASER_PURCHASE_SUMMARY_DINING = '109',
  /** 供方采购汇总表 --- 按食堂 */
  SUPPLY_PROCUREMENT_SUMMARY_DINING = '110',
  /** 监管方采购汇总表 --- 按食堂 */
  MANAGE_PROCUREMENT_SUMMARY_DINING = '111',
  /** 监管方申购需求汇总-按需方 */
  MANAGE_APPLY_PURCHASE_SUMMARY_DEMAND = '112',
  /** 监管方申购需求汇总-按食堂 */
  MANAGE_APPLY_PURCHASE_SUMMARY_DINING = '108',
  /** 需方申购商品明细 -- 按食堂 */
  PURCHASER_APPLY_PURCHASE_SUMMARY_DINING = '105',
}

export interface GetGlobalConfigRequest {
  dictTypeList?: OptionType[];
}

export type GetGlobalConfigResponse = {
  /** 全局选项的映射关系 */
  dictInfoMap: Record<OptionType, SysDictItem[]>;
  purchaseMode: PurchaseMode;
} & Omit<GlobalConfigVo, 'key'>;

export interface UpdateGlobalRequest {
  id: number;
  purchaseLeadDay: number;
  /**
   * @deprecated
   */
  isAudit: number;
  /** 平台审核采购单 */
  purchaseAudit: number;
  /** 平台审核对账单 */
  statementAudit: number;
  /** 采购合同审核 */
  contractReview: number;
  commissionRatio: number;
  isReceiving: number;
  receivingDay?: number;
  isReconciliation: number;
  reconciliationDay?: number;
  cancelVfnMode: number;
  supplierWithoutReportShipment: number;
}

export type GetMenuListResponse = Menu[];
export interface GetExportFieldsRequest {
  /** 导出字段类型 */
  template: ExportFiledType;
}

export interface GetExportFieldsResponse {
  data: ExportTemplate[];
  defaultFields: number[];
}

export interface ExportFileByQueryRequest {
  /** 是否全选 */
  isAll?: boolean;
  /** 导出的类型 */
  type: ExportFiledType;
  /** 需要导出的数据的keys */
  keys?: (string | number | bigint)[];
  /** 需要导出的数据的字段名 */
  exportStr: string[];
  /** 过滤条件 */
  filter?: Record<string, any>;
}
